<div class="flex flex-column-m flex-column-s flex-middle-l flex-middle-x flex-justify-between m-b-9 m-b-5-s m-b-5-m">
    <account-back class="block p-l-2 m-b-7-s m-b-7-m"
                  [title]="'Your wishlist' | translate"></account-back>
    @if (wishlist.items.length) {
    <button type="button"
            iCmsModalOpen="wishlist_share_modal"
            class="button-1 w-12-s w-12-s">
        <span translate>Share Wishlist</span>
    </button>
    }

</div>


@if (!wishlist.items.length) {
<p class="s1">
    {{ 'You haven`t added any products to your list yet.' | translate }}
</p>
}

@for (item of wishlist.items; track item) {
<product class="c-6-set-s c-4-set-x c-4-set-m c-4-set-l"
         [modelId]="item.productId"></product>
}
